import LoadScene from '@scenes/LoadScene';
import StartScene from '@scenes/StartScene';
import GameScene from '@scenes/GameScene';
import LoadEndScene from '@scenes/LoadEndScene';
import EndScene from '@scenes/EndScene';

export default [
  { key: 'LoadScene', scene: LoadScene, autoStart: true },
  { key: 'StartScene', scene: StartScene },
  { key: 'GameScene', scene: GameScene },
  { key: 'LoadEndScene', scene: LoadEndScene },
  { key: 'EndScene', scene: EndScene },
];
